<script>
    import { db } from './firebase'
    import { onMount } from 'svelte'
	import Header from './Header.svelte'
    export let params = {}
	import { push } from 'svelte-spa-router'


    let formData = []
	let loading = true

    onMount(() => {
		getFormData()
	})

    const getFormData = () => {
		db.collection('forms').doc(params.form).get().then((doc) => {
			if (doc.exists) {
				formData = doc.data()
				formData.questions.forEach(question => {
					if (question.choiceOptions != undefined) {		
						question.choiceOptions = question.choiceOptions.join(";\r\n")
					}
				})
				loading = false
			} else {
				console.log("No such document!")
			}
		}).catch((error) => {
			console.log(error);
		})
	}
	const addNewQuestion = () => {
		formData.questions = [...formData.questions, {question: '', type: 'short-text'}]
	}
	const duplicateQuestion = index => {
		formData.questions = [...formData.questions, formData.questions[index]]
	}
	const saveChanges = () => {
		formData.questions.forEach(question => {
			if (!Array.isArray(question.choiceOptions) && question.choiceOptions != undefined) {
				question.choiceOptions = question.choiceOptions.replace(/(\r\n|\n|\r)/gm,"").split(";")
				console.log(question.choiceOptions)
			}
		})
		db.collection('forms').doc(params.form).update(formData)
	}
	const changeTitle = event => {
		console.log(event.toElement.innerText)
		let newTitle = prompt('Enter a new title')
		formData.title = newTitle
	}
</script>

<!-- <Header title={'Editing ' + formData.title}/> -->
{#if !loading}
<div class="page">
	<div class="sidebar">
		<input type="text" class="search">
		<div class="form">
			<div class="line"/>
			<p class="name">OKS Census v6</p>
			<p class="label">50 questions</p>
		</div>
	</div>
	<div class="content">
		<div class="title-bar">
			<div class="label-button" on:click={() => push('/' + params.form + '/results')}>Go to Results</div>
			<p class="title">{formData.title}</p>
			<div class="save-button" on:click={saveChanges}>Save</div>
			<!-- <div class="save-button"><img src="/assets/tick.svg" alt="" class="icon">Save</div> -->
		</div>
		<!-- <h1 on:click={changeTitle}>{formData.title}</h1>
		<p class="label">{params.form}</p>
		<input type="checkbox" bind:checked={formData.formOpen}> Form {formData.formOpen ? 'open' : 'closed'} -->
		{#each formData.questions as question, index}
		<div class="question">
        	<p class="question-label"><span>{index + 1}</span></p>
			<input type="text" class="seamless h2" bind:value={question.question}>
			<select class="seamless question-type" bind:value={question.type}>
				<option value="single-choice">Single Choice</option>
				<option value="multiple-choice">Multiple Choice</option>
				<option value="multiple-choice-with-maximum">Multiple Choice with Maximum Selections</option>
				<option value="short-text">One Line Text</option>
				<option value="long-text">Multi Line Text</option>
				<option value="slider-10">Slider 1 - 10</option>
				<option value="rank-list">Rank Options</option>
			</select>
			<select class="seamless data-visual-type" bind:value={question.dataVisual}>
				<option value="pie">Pie Chart</option>
				<option value="bar-chart">Bar Chart</option>
				<option value="list">Bulleted List</option>
				<option value="horizontal-bar-chart">Horizontal Bar Chart</option>
			</select>
			{#if question.type == 'single-choice' || question.type == 'multiple-choice' || question.type == 'rank-list'}
				<!-- {#each question.choiceOptions as option, index}
					<input type="text" class="choice-option" bind:value={option} placeholder={'option ' + (index + 1)}>
				{/each}
				<button on:click={() => question.choiceOptions = [...question.choiceOptions, ""]}>Add Option</button>
				<button on:click={() => {question.choiceOptions.pop(); question.choiceOptions = question.choiceOptions}}>Remove Option</button> -->
				<span class="input seamless" role="textbox" contenteditable bind:textContent={question.choiceOptions}></span>
			{:else if question.type == 'multiple-choice-with-maximum'}
				<span class="input" role="textbox" contenteditable bind:textContent={question.choiceOptions}></span>
				<input class="max-selections-input input" type="number" bind:value={question.maximumSelections} placeholder="Maximum Selectable">
			{/if}
			<!-- <button on:click={() => duplicateQuestion(index)}>Duplicate Question {index + 1}</button> -->
		</div>
		{/each}
		<div class="question">
			<p class="question-label"><span>+</span></p>
			<h2 on:click={addNewQuestion}>Click to add question.</h2>
		</div>
		<!-- <button class="cta" on:click={addNewQuestion}>New Question</button> -->
		<h2>Post-Submit Message</h2>
		<input type="text" bind:value={formData.submittedMessage}>
		<!-- <button class="cta" on:click={saveChanges}>Save Changes</button> -->
	</div>
</div>
{/if}

<style>

	input.choice-option {
		margin: 0 40px 4px;
		display: block;
	}
	/* .question {
		padding-top: 40px;
	} */
	span.input {
		background: var(--background-secondary);
		width: 400px;
		display: block;
		white-space: pre;
	}

	.form {
		display: grid;
		grid-template: 1fr / 22px 1fr;
	}
	.form .line {
		width: 3px;
		height: 45px;
		background: var(--background-tertiary);
		grid-row: 1;
		grid-column: 1;
	}
	.form p.name {
		grid-row: 1;
		grid-column: 2;
		align-self: start;
		margin: 0;
	}
	.form p.label {
		grid-row: 1;
		grid-column: 2;
		align-self: end;
		margin: 0;
		font-size: 14px;
	}

	.question {
		display: grid;
		grid-template: 60px 1fr / 45px 1fr;
		margin: 50px 7%;
	}
	.question .question-label {
		grid-row: 1;
		grid-column: 1;
		align-self: start;
	}
	.question .h2, .question h2 {
		grid-row: 1;
		grid-column: 2;
		align-self: start;
	}
	.question .question-type {
		grid-row: 1;
		grid-column: 2;
		align-self: end;
		margin: 0;
	}
	.question span, .question .question-responses {
		grid-row: 2;
		grid-column: 2;
	}
	.question .max-selections-input {
		grid-column: 2;
		grid-row: 3;
	}
</style>